export default __webpack_public_path__ + "static/banner_back-94ef4653f4d2175ff1a5684c767547d2.webp";